"use client";
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/offer.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from "react-bootstrap";
import https from "https";
import { useState, useEffect } from "react";
import Loading from "./loading";
import { formatEventDate } from "@/app/utils/formatDate";
import CodeDisplay from "@/app/utils/content";
import CaroeuslOffer from "@/app/components/offer-carousel";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData(slug) {
  const query = `
{
  pageData: qleventofferBy(uri: "${slug}") {
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    eventsOffers {
      content
      detailsList {
        description
        title
      }
      endDate
      startDate
      customizeDateText
      reserveLink
      featureImage {
        node {
          mediaItemUrl
        }
      }
    }
    taxoffers {
      nodes {
        name
      }
    }
    title
  }
}
  `;

  const res = await fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`, {
    httpsAgent: agent,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
    next: {
      revalidate: 0,
    },
  });

  const { data } = await res.json();

  return data;
}

export default async function EventsOffersInner({ params }) {
  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [offer_title, setOfferTitle] = useState("");
  const [offer_tags, setOfferTags] = useState([]);
  const [offer_details, setOfferDetails] = useState([]);
  const [offer_content, setOfferContent] = useState("");
  const [offer_date, setOfferDate] = useState("");
  const [offer_link, setOfferLink] = useState("");

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    async function fetchData() {
      if (params.slug) {
        const query = `/seen-events-offers/${params.slug}/`;
        const page = await getPageData(query);
        if (page) {
          // console.log(page);
          if (page.pageData) {
            setPageData(page.pageData);

            if (page.pageData.title) {
              if (page.pageData.title) {
                setOfferTitle(page.pageData.title);
              }
            }

            if (page.pageData.pageBan) {
              if (page.pageData.pageBan.bannerText) {
                setPageBannerText(page.pageData.pageBan.bannerText);
              }
              if (page.pageData.pageBan.bannerSlider) {
                setPageBannerSliders(page.pageData.pageBan.bannerSlider);
              }
            }

            let start_date = "";
            let end_date = "";
            let custom_date = "";

            if (page.pageData.eventsOffers) {
              if (page.pageData.eventsOffers) {
                if (page.pageData.eventsOffers.startDate) {
                  start_date = page.pageData.eventsOffers.startDate;
                }
                if (page.pageData.eventsOffers.customizeDateText) {
                  custom_date = page.pageData.eventsOffers.customizeDateText;
                }
                if (page.pageData.eventsOffers.endDate) {
                  end_date = page.pageData.eventsOffers.endDate;
                }
                if (page.pageData.eventsOffers.detailsList) {
                  setOfferDetails(page.pageData.eventsOffers.detailsList);
                }
                if (page.pageData.eventsOffers.content) {
                  setOfferContent(page.pageData.eventsOffers.content);
                }
                if (page.pageData.eventsOffers.reserveLink) {
                  setOfferLink(page.pageData.eventsOffers.reserveLink);
                }
              }
            }

            const eventDateText = formatEventDate(
              start_date,
              end_date,
              custom_date,
            );
            if (eventDateText) {
              setOfferDate(eventDateText);
            }

            if (page.pageData.taxoffers) {
              if (page.pageData.taxoffers.nodes) {
                setOfferTags(page.pageData.taxoffers.nodes);
              }
            }
          }
          setPreLoaderEnable(false);
        }
      }
    }
    fetchData();
    return () => {};
  }, [params.slug]);

  useEffect(() => {
    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;
      const locomotiveScroll = new LocomotiveScroll();
    })();
  }, []);

  if (pre_loader_enabled) {
    return <Loading />;
  }

  return (
    <>
      <section className="inner-banner inner-banner-offers position-relative">
        {page_banner_sliders && (
          <CaroeuslOffer page_banner_sliders={page_banner_sliders} />
        )}
        <div
          className={`${styles.single_banner_text} inner-banner-offers-text ${page_banner_sliders.length > 0 ? "" : "position-relative bg-dark-green green-mesh without-images"}`}
        >
          <div className="main-short-wrapper z-top position-relative">
            <div className={styles.single_banner_text_inner}>
              <div className="d-flex flex-wrap tag-wrap-inner">
                {offer_tags.length > 0 &&
                  offer_tags.map((tag, index) => (
                    <div className={styles.offer_box_right_tag} key={index}>
                      {tag.name}
                    </div>
                  ))}
              </div>
              <h1 className="section-heading section-heading--white heading-padding">
                {offer_title}
              </h1>
              <div
                className={`d-flex flex-wrap ${styles.offer_box_details_wrap}`}
              >
                <div className={styles.offer_box_details}>
                  <p className="paragraph-small paragraph--white para-bold all-caps before-icon">
                    Date
                  </p>
                  <p className="paragraph-small text-left-mobile paragraph--white before-text">
                    {offer_date}
                  </p>
                </div>
                {offer_details.map((offer, index) => (
                  <div className={styles.offer_box_details} key={index}>
                    <p className="paragraph-small paragraph--white para-bold all-caps before-icon">
                      {offer.title}
                    </p>
                    <p className="paragraph-small text-left-mobile paragraph--white before-text">
                      {offer.description}
                    </p>
                  </div>
                ))}
              </div>
              {offer_link && (
                <a
                  href={offer_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`reserve-btn reserve-btn--yellow ${styles.reserve_now}`}
                >
                  reserve now
                </a>
              )}
            </div>
          </div>
        </div>
      </section>
      {page_banner_sliders.length === 0 && (
        <section className="bg-dark-green green-mesh inner-banner-text-wrap position-relative">
          <div className="inner-banner-text z-top">
            <h2 className="all-caps section-heading-large section-heading--yellow m-0">
              {page_banner_text}
            </h2>
          </div>
        </section>
      )}
      <section className="section-padding-bottom bg-dark-green green-mesh">
        <div className="middle-wrap middle-wrap-single z-top">
          <div className="the_content_div">
            <CodeDisplay code={offer_content} />
          </div>
        </div>
      </section>
    </>
  );
}
